function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forEach, values } from 'lodash';
import { PreguntaForm } from './pregunta-form';
export var BloqueForm = /*#__PURE__*/function () {
  function BloqueForm(data) {
    _classCallCheck(this, BloqueForm);
    // pregs: PreguntaForm[] = []
    _defineProperty(this, "pregsList", []);
    _defineProperty(this, "pregs", {});
    _defineProperty(this, "preguntas", {});
    _defineProperty(this, "eliminar", false);
    _defineProperty(this, "restaurar", false);
    this.data = data.data;
    this.pregsList = values(data.pregsList).filter(function (preg) {
      return preg.data.activo;
    }).map(function (p) {
      return new PreguntaForm(p.data).update(p);
    });
  }
  return _createClass(BloqueForm, [{
    key: "update",
    value: function update(response) {
      // this.data = response
      this.data = response.data;
      this.pregsList = values(response.pregsList).filter(function (preg) {
        return preg.data.activo;
      }).map(function (p) {
        return new PreguntaForm(p.data).update(p);
      });
      this.eliminar = false;
      this.restaurar = false;
      return this;
    }
  }, {
    key: "nuevaPregunta",
    value: function nuevaPregunta(preg) {
      var _p = new PreguntaForm({
        activo: true,
        visibleEnForm: true
      });
      _p.desdePregunta(preg);
      this.pregsList.push(_p);
    }
  }, {
    key: "beforeSave",
    value: function beforeSave() {
      // para todas las preguntas, preparar el guardado
      forEach(this.pregsList, function (p) {
        return p.beforeSave();
      });
    }
  }, {
    key: "subirPreg",
    value: function subirPreg(idx) {
      if (idx < 1) {
        console.warn('No puedes subir el primero');
        return;
      }
      var panterior = this.pregsList[idx - 1];
      var thisp = this.pregsList[idx];
      this.pregsList.splice(idx - 1, 1, thisp);
      this.pregsList.splice(idx, 1, panterior);
    }
  }, {
    key: "bajarPreg",
    value: function bajarPreg(idx) {
      if (idx >= this.pregsList.length - 1) {
        console.warn('No puedes bajar el último');
        return;
      }
      var psiguiente = this.pregsList[idx + 1];
      var thisp = this.pregsList[idx];
      this.pregsList.splice(idx + 1, 1, thisp);
      this.pregsList.splice(idx, 1, psiguiente);
    }
  }]);
}();